// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { ElectronicInvoiceFragment } from './electronic-invoice.fragment.generated';
import { ResourceValidationResultFragmentFragment } from '../../../../shared/graphql/fragments/generated/resource-validation-result.fragment.generated';
export type ElectronicInvoiceDataFragment = { __typename?: 'ElectronicInvoiceDataDTO', eInvoiceSendTimestamp: LocalDateTime | null, eInvoiceStatus: Types.EInvoiceStatusEnumDto | null, invoiceId: number, xsdValidationError: string | null, invoice: { __typename?: 'InvoiceDTO', amount: number, block: string | null, date: LocalDate | null, id: number, ownerCorporateDataId: number, progressive: number, masterInvoice: boolean, holder: { __typename?: 'InvoiceHolderDTO', id: number, fiscalCode: string | null, vatNumber: string | null, fullName: string, name: string | null, surname: string | null, corpName: string | null, address: string | null, city: string | null, cityId: number | null, mail: string | null, mobile: string | null, invoiceHolderType: Types.InvoiceHolderTypeDto, invoiceDocumentType: Types.InvoiceDocumentTypeDto | null } | null }, resourceValidationResults: Array<{ __typename?: 'ResourceValidationResultDTO', resourceId: number, validationErrors: Array<{ __typename?: 'ValidationErrorDTO', errorCode: string, fieldName: string | null, translationKey: string } | null> | null }> };

export const ElectronicInvoiceDataFragment = gql`
    fragment ElectronicInvoiceData on ElectronicInvoiceDataDTO {
  eInvoiceSendTimestamp
  eInvoiceStatus
  invoiceId
  xsdValidationError
  invoice {
    ...ElectronicInvoice
  }
  resourceValidationResults {
    ...ResourceValidationResultFragment
  }
}
    ${ElectronicInvoiceFragment}
${ResourceValidationResultFragmentFragment}`;
/* eslint-enable */